module.exports = __webpack_public_path__ + "static/media/img_taiwan.dae0038e.webp";